import React from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';

const cx = classnames.bind(style);

interface IProps {
  dataList: number;
}

export const Rating = (props: IProps) => {
  const {dataList} = props;
  const ary = _.times(5, (n) => {
    const notEmpty = dataList - n < 0.5 ? 'half' : 'full';
    const notFull = dataList - n < 0.25 ? 'empty' : notEmpty;
    return  n + 1 <= dataList ? 'full' : notFull;
  });
  return (
    <div className={cx('rating')}>
      <span>{dataList}</span>
      {_.map(ary, (d, i) => (
        <div key={i} className={cx('star', d)}>
          <div className={cx('inner')}></div>
        </div>
      ))}
    </div>
  );
};

export default Rating;
